// extracted by mini-css-extract-plugin
export default {"contact-item":"Contact_contact-item__v07s5","contact-label":"Contact_contact-label__rcJKN","contact-link":"Contact_contact-link__G-Umi"};